module.exports = "/static/Images/images/VerySatisfied.png";